module.exports = __webpack_public_path__ + "img/bot.3a0c1039.gif";